import React from 'react';
import { useNavigate } from 'react-router-dom';

import { formatNull } from '../Utils/GlobalUtils';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

const ProfileModal = ({ closeModal, fiodata }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()} style={{width: '450px'}}>
                <div className={styles.header}>
                    <h1>Учётная запись</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className={styles.profile}>
                        <h3>{fiodata.lastname} {fiodata.firstname} {fiodata.surname}</h3>
                        <h3>{fiodata.email}</h3>
                        <div className='lineSeparator'></div>
                        <p>Тип учётной записи: {formatNull(fiodata.role)}</p>
                        <div className='lineSeparator'></div>
                        <p className='aWithLink' onClick={() => navigate('/legal/terms-of-use')}>Условия использования</p>
                        <p className='aWithLink' onClick={() => navigate('/legal/privacy-policy')}>Политика конфиденциальности</p>
                    </div>
                </div>
                <div className={styles.bottom}>
                    {loading ? <Loading />
                    :
                    <a className='button red maxWidth' href='/auth/logout' onClick={() => setLoading(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="signout"><path fill="currentColor" d="M4,12a1,1,0,0,0,1,1h7.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76,1,1,0,0,0-.21-.33l-4-4a1,1,0,1,0-1.42,1.42L12.59,11H5A1,1,0,0,0,4,12ZM17,2H7A3,3,0,0,0,4,5V8A1,1,0,0,0,6,8V5A1,1,0,0,1,7,4H17a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V16a1,1,0,0,0-2,0v3a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V5A3,3,0,0,0,17,2Z"></path></svg>
                        Выйти из учётной записи
                    </a>}
                </div>
            </div>
        </div>
    );
};

export default ProfileModal;
